import React from 'react';
import { Link } from 'react-router-dom';
import './cta.css';

const CTA = () => (
  <div className="cta">
    <div className="cta-content">
      <p>Are you ready to start something new?</p>
      <h3>Contact Etheware Today & start exploring the endless possibilities.</h3>
    </div>
    <div className="cta-btn">
      <button type="button"><p><Link to="/contact">Get Started</Link></p></button>
    </div>
  </div>
);

export default CTA;
